import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Egyptian National ID generator following Single Responsibility Principle
 */
export class EgGenerator extends BaseGenerator {
  generate(options = {}) {
    const { birthDate = null } = options;

    let centuryYearMonthDay;
    if (birthDate) {
      const date = new Date(birthDate);
      const year = date.getFullYear();
      const century = year >= 2000 ? '3' : '2';
      const yearStr = year.toString().slice(-2);
      const month = this.padZero(date.getMonth() + 1, 2);
      const day = this.padZero(date.getDate(), 2);
      centuryYearMonthDay = century + yearStr + month + day;
    } else {
      const century = this.randomInt(0, 1) ? '2' : '3'; // 2 for 1900s, 3 for 2000s
      const year = this.padZero(this.randomInt(0, 99), 2);
      const month = this.padZero(this.randomInt(1, 12), 2);
      const day = this.padZero(this.randomInt(1, 28), 2);
      centuryYearMonthDay = century + year + month + day;
    }

    // Governorate code (2 digits)
    const governorate = this.padZero(this.randomInt(1, 35), 2);

    // Sequence number (6 digits)
    const sequence = this.randomDigits(6);

    return centuryYearMonthDay + governorate + sequence;
  }
}